import { getPermissions } from "../../../api";
import { RoleState, GeneralPermissions, UserPermission } from "../../../types";
import { CDCM_ROLE_NAMES } from "../constants";

export function getUserRoles(roles: Array<RoleState>): string {
  let userRoles = "";
  roles.forEach((ro: RoleState) => {
    if (CDCM_ROLE_NAMES.includes(ro.roleName)) {
      userRoles += `${ro.roleName} `;
    }
  });
  return userRoles;
}

export async function getUserPermissions(cdkId: string): Promise<{
  userPermissions: GeneralPermissions;
  permissionsList: Array<UserPermission>;
}> {
  const permissionsList = await getPermissions(cdkId);
  const hasAuditAccess = permissionsList.some(
    (p: UserPermission) => p.permission === "SETUPS_AUDIT_ACCESS",
  );
  return {
    userPermissions: {
      hasAuditAccess,
    },
    permissionsList,
  };
}
